import { Alert, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ErrorMsg = ({ severity = "error", message, open, onClose, height, sx }) => {
    return (
        <Box
            component="div"
            sx={{
                flex: 1,
                height: height || 1,
                position: "relative",
            }}
        >
            {open &&
                <Alert
                    severity={severity}
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={onClose}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }
                    sx={{
                        justifyContent: "center",
                        alignItems: "center",
                        py: 0.5,
                        ...sx,
                        position: "fixed",
                        minWidth: {
                            xs: "calc(100vw - 64px)",
                            sm: 270,
                            lg: 270
                        },
                        maxWidth: {
                            xs: "100%",
                            sm: 364,
                        },
                        top: 100,
                        left: {
                            xs: "50%",
                            sm: 190,
                            md: 270,
                            lg: 330,

                        },
                        transform: "translate(-50%, -50%)",
                        zIndex: 9,
                        boxShadow: 3
                    }}
                >
                    {message}
                </Alert>
            }
        </Box>
    );
};

export default ErrorMsg;
